import { render, staticRenderFns } from "./SubmitTeacher.vue?vue&type=template&id=4ad908b3"
import script from "./SubmitTeacher.vue?vue&type=script&lang=js"
export * from "./SubmitTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports